module.exports = __webpack_public_path__ + "static/media/promote-socials-2.3b85ff5f.png";